export default "__VITE_ASSET__k2TJCFwZ__"